module.exports = {
    APIDoc:{
        mainTitle:"台灣華語電影資料庫 示範用 API 使用說明",
        mainText:"本示範資料庫建置有資料介接功能 (API)。以下為各API之說明",
        paragraph:[
            {
                number:"1",
                pTitle:"電影資料查詢",
                pText:"查詢電影資料 API，有下列5隻：",
                subParagraph:[
                    {
                        number:"1.1",
                        spTitle:"電影資料簡目搜尋 API (全欄位)",
                        spText:"使用者輸入查詢字詞、每頁筆數、第幾頁、排序欄位、排序方式等參數後，API將以輸入字詞搜尋電影權威資料內所有欄位，搜尋後回傳與此字詞相關的電影簡目資料",
                        spUrl:"/api/movie/basicQuery/frontend/limit/:limitNumber/pageNumber/:pageNumber/orderColumn/:orderColumn/orderType/:orderType/query/:query",
                        inputTableText:null,
                        inputTable:[
                            {
                                iTitle:"limitNumber",
                                iType:"Integer",
                                iText:"<div>回傳每頁筆數：有時搜尋結果會有幾百幾千筆，所以API會分頁回傳。此參數設定回傳結果一頁有幾筆資料。<p>允許數值：此數值為大於0正整數，無上限。</p></div>"
                            },
                            {
                                iTitle:"pageNumber",
                                iType:"Integer",
                                iText:"<div>回傳第幾頁資料：有時搜尋結果會有幾百幾千筆，所以API會分頁回傳。此參數設定要回傳搜尋結果的第幾頁資料。<p>允許數值：此數值為大於0正整數，上限不超過搜尋結果總筆數除以每頁筆數。</p></div>"
                            },
                            {
                                iTitle:"orderColumn",
                                iType:"String",
                                iText:"<div>排序欄位：此參數為欄位名，設定參數後系統會將搜尋結果依該欄位進行升冪或降冪排序。<p>允許數值：符合之欄位名，<code>Movie_SysID</code> (系統識別號)、<code>Movie_SubCategoryOne</code>(電影種類-長短片)、<code>Movie_SubCategoryTwo</code> (電影種類)、<code>Movie_TitleMain</code> (電影主要名稱)、<code>Movie_TitleTranslation</code> (電影翻譯名稱)、<code>Movie_TitleOther</code> (電影其他名稱)、<code>Movie_ProductionDate</code> (電影出品日期)、<code>Movie_ProductionLocation</code> (電影製作國家)、<code>Movie_ProductionCompany</code> (電影製作公司)、<code>Movie_Producer</code> (電影製作者)、<code>Movie_DramaContent</code> (電影劇情大綱)、<code>Movie_Rating</code> (電影分級)、<code>Movie_Language</code> (電影語言)。</p></div>"
                            },
                            {
                                iTitle:"orderType",
                                iType:"String",
                                iText:"<div>排序方式：設定搜尋果為升冪或降冪排序 (依orderColumn欄位)。<p>允許數值：<code>asc</code> (升冪)、<code>desc</code>(降冪)</p></div>"
                            },
                            {
                                iTitle:"query",
                                iType:"ObjectArray",
                                iText:"<div>搜尋字詞：使用者於此設定想要查詢的關鍵字，因本隻API允許複數關鍵字的搜尋，所以回傳為字詞組成的陣列。<p>允許數值：符合下列形式之物件陣列： <code>{`[{boolean:BOOLEAN1,keyword:KEYWORD1},{boolean:BOOLEAN2,keyword:KEYWORD2},...]`}</code>，並且須將此物件陣列經由 <code> URI 加密為字串</code>始傳入API。</p><p>物件屬性：</p><p><code>boolean</code>: 為此關鍵字與其他關鍵字之關係是 <code>AND</code> (交集) 或 <code>OR</code> (聯集)。</p><p><code>keyword</code>: 為使用者想搜尋的關鍵字，一個關鍵字的中文字數勿超過50字。</p></div>"
                            }
                        ],
                        outputTableText:"本隻API呼叫成功後，搜尋結果將會以陣列回傳，每筆資料為此陣列中的一個物件，資料的欄位以物件屬性呈現，以下說明各物件屬性 (也就是資料欄位)",
                        outputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：該筆電影的系統唯一ID，藉由此ID可再進一步查詢該電影的細節內容、演職員表、相關藏品等。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryOne",
                                iType:"String",
                                iText:"<div>電影種類 (長短片)：該電影是長片或短片。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryTwo",
                                iType:"String",
                                iText:"<div>電影種類：該電影的種類，如劇情片、紀錄片等。</div>"
                            },
                            {
                                iTitle:"Movie_TitleMain",
                                iType:"String",
                                iText:"<div>電影主要片名：該電影的主要片名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleTranslation",
                                iType:"String",
                                iText:"<div>電影翻譯片名：該電影的英譯或其他語言的譯名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleOther",
                                iType:"String",
                                iText:"<div>電影其他片名：該電影其他片名。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionDate",
                                iType:"String",
                                iText:"<div>電影出品日期：該電影的出品日期。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionLocation",
                                iType:"String",
                                iText:"<div>電影出品國家：該電影的出品國家。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionCompany",
                                iType:"String",
                                iText:"<div>電影製作公司：該電影的製作公司。</div>"
                            },
                            {
                                iTitle:"Movie_Producer",
                                iType:"String",
                                iText:"<div>電影製作人：該電影的製作人。</div>"
                            },
                            {
                                iTitle:"Movie_DramaContent",
                                iType:"String",
                                iText:"<div>電影劇情大綱：該電影的劇情介紹。</div>"
                            },
                            {
                                iTitle:"Movie_Rating",
                                iType:"String",
                                iText:"<div>電影分級：該電影的分級。</div>"
                            },
                            {
                                iTitle:"Movie_Language",
                                iType:"String",
                                iText:"<div>電影語言：該電影的語言。</div>"
                            },
                            {
                                iTitle:"Movie_TotalCount",
                                iType:"String",
                                iText:"<div>搜尋結果總筆數：本次搜尋所搜尋到的電影總筆數。</div>"
                            },
                        ]

                    },
                    {
                        number:"1.2",
                        spTitle:"電影資料簡目搜尋 API (個別欄位)",
                        spText:"使用者輸入查詢字詞(含指定搜尋欄位)、每頁筆數、第幾頁、排序欄位、排序方式等參數後，API將以輸入字詞搜尋電影權威資料內指定搜尋欄位，搜尋後回傳與此字詞相關的電影簡目資料",
                        spUrl:"/api/movie/advanceQuery/frontend/limit/:limitNumber/pageNumber/:pageNumber/orderColumn/:orderColumn/orderType/:orderType/query/:query",
                        inputTableText:null,
                        inputTable:[
                            {
                                iTitle:"limitNumber",
                                iType:"Integer",
                                iText:"<div>回傳每頁筆數：有時搜尋結果會有幾百幾千筆，所以API會分頁回傳。此參數設定回傳結果一頁有幾筆資料。<p>允許數值：此數值為大於0正整數，無上限。</p></div>"
                            },
                            {
                                iTitle:"pageNumber",
                                iType:"Integer",
                                iText:"<div>回傳第幾頁資料：有時搜尋結果會有幾百幾千筆，所以API會分頁回傳。此參數設定要回傳搜尋結果的第幾頁資料。<p>允許數值：此數值為大於0正整數，上限不超過搜尋結果總筆數除以每頁筆數。</p></div>"
                            },
                            {
                                iTitle:"orderColumn",
                                iType:"String",
                                iText:"<div>排序欄位：此參數為欄位名，設定參數後系統會將搜尋結果依該欄位進行升冪或降冪排序。<p>允許數值：符合之欄位名，<code>Movie_SysID</code> (系統識別號)、<code>Movie_SubCategoryOne</code>(電影種類-長短片)、<code>Movie_SubCategoryTwo</code> (電影種類)、<code>Movie_TitleMain</code> (電影主要名稱)、<code>Movie_TitleTranslation</code> (電影翻譯名稱)、<code>Movie_TitleOther</code> (電影其他名稱)、<code>Movie_ProductionDate</code> (電影出品日期)、<code>Movie_ProductionLocation</code> (電影製作國家)、<code>Movie_ProductionCompany</code> (電影製作公司)、<code>Movie_Producer</code> (電影製作者)、<code>Movie_DramaContent</code> (電影劇情大綱)、<code>Movie_Rating</code> (電影分級)、<code>Movie_Language</code> (電影語言)。</p></div>"
                            },
                            {
                                iTitle:"orderType",
                                iType:"String",
                                iText:"<div>排序方式：設定搜尋果為升冪或降冪排序 (依orderColumn欄位)。<p>允許數值：<code>asc</code> (升冪)、<code>desc</code>(降冪)</p></div>"
                            },
                            {
                                iTitle:"query",
                                iType:"ObjectArray",
                                iText:"<div>搜尋字詞：使用者於此設定想要查詢的關鍵字，因本隻API允許複數關鍵字的搜尋，所以回傳為字詞組成的陣列。<p>允許數值：符合下列形式之物件陣列： <code>{`[{boolean:BOOLEAN1, keyword:KEYWORD1, columnName:ColumnName1, operator:Operator1},{boolean:BOOLEAN2, keyword:KEYWORD2, columnName:ColumnName2, operator:Operator2},...]`}</code>，並且須將此物件陣列經由 <code> URI 加密為字串</code>始傳入API。</p><p>物件屬性：</p><p><code>boolean</code>: 為此關鍵字與其他關鍵字之關係是 <code>AND</code> (交集) 或 <code>OR</code> (聯集)。</p><p><code>keyword</code>: 為使用者想搜尋的關鍵字，一個關鍵字的中文字數勿超過50字。</p><p><code>columnName</code>: 為使用者想搜尋的指定欄位，輸入該欄位的名稱：<code>Movie_SysID</code> (系統識別號)、<code>Movie_SubCategoryOne</code>(電影種類-長短片)、<code>Movie_SubCategoryTwo</code> (電影種類)、<code>Movie_TitleMain</code> (電影主要名稱)、<code>Movie_TitleTranslation</code> (電影翻譯名稱)、<code>Movie_TitleOther</code> (電影其他名稱)、<code>Movie_ProductionDate</code> (電影出品日期)、<code>Movie_ProductionLocation</code> (電影製作國家)、<code>Movie_ProductionCompany</code> (電影製作公司)、<code>Movie_Producer</code> (電影製作者)、<code>Movie_DramaContent</code> (電影劇情大綱)、<code>Movie_Rating</code> (電影分級)、<code>Movie_Language</code> (電影語言)。</p><p><code>operator</code>: 搜尋字於該欄位的搜尋邏輯，可輸入<code>Like</code>(包含)、<code>Equal</code>(等於)、<code>Greater</code>(大於)、<code>Smaller</code>(小於) 等。</p></div>"
                            }
                        ],
                        outputTableText:"本隻API呼叫成功後，搜尋結果將會以陣列回傳，每筆資料為此陣列中的一個物件，資料的欄位以物件屬性呈現，以下說明各物件屬性 (也就是資料欄位)",
                        outputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：該筆電影的系統唯一ID，藉由此ID可再進一步查詢該電影的細節內容、演職員表、相關藏品等。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryOne",
                                iType:"String",
                                iText:"<div>電影種類 (長短片)：該電影是長片或短片。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryTwo",
                                iType:"String",
                                iText:"<div>電影種類：該電影的種類，如劇情片、紀錄片等。</div>"
                            },
                            {
                                iTitle:"Movie_TitleMain",
                                iType:"String",
                                iText:"<div>電影主要片名：該電影的主要片名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleTranslation",
                                iType:"String",
                                iText:"<div>電影翻譯片名：該電影的英譯或其他語言的譯名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleOther",
                                iType:"String",
                                iText:"<div>電影其他片名：該電影其他片名。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionDate",
                                iType:"String",
                                iText:"<div>電影出品日期：該電影的出品日期。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionLocation",
                                iType:"String",
                                iText:"<div>電影出品國家：該電影的出品國家。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionCompany",
                                iType:"String",
                                iText:"<div>電影製作公司：該電影的製作公司。</div>"
                            },
                            {
                                iTitle:"Movie_Producer",
                                iType:"String",
                                iText:"<div>電影製作人：該電影的製作人。</div>"
                            },
                            {
                                iTitle:"Movie_DramaContent",
                                iType:"String",
                                iText:"<div>電影劇情大綱：該電影的劇情介紹。</div>"
                            },
                            {
                                iTitle:"Movie_Rating",
                                iType:"String",
                                iText:"<div>電影分級：該電影的分級。</div>"
                            },
                            {
                                iTitle:"Movie_Language",
                                iType:"String",
                                iText:"<div>電影語言：該電影的語言。</div>"
                            },
                            {
                                iTitle:"Movie_TotalCount",
                                iType:"String",
                                iText:"<div>搜尋結果總筆數：本次搜尋所搜尋到的電影總筆數。</div>"
                            },
                        ]

                    },
                    {
                        number:"1.3",
                        spTitle:"電影權威資料 詳細資料 API",
                        spText:"使用者輸入電影的系統識別號後，API即回傳此部的電影詳細資料 (不包括演員表、職員表、相關藏品)",
                        spUrl:"/api/movie/fetch/MovieMainInfo/:Movie_SysID",
                        inputTableText:null,
                        inputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：每部電影權威資料的識別ID。</div>"
                            }
                        ],
                        outputTableText:"本隻API呼叫成功後，搜尋結果將會以陣列回傳，電影詳細資料位於陣列第一個物件 (array[0])，資料的欄位以物件屬性呈現，以下說明各物件屬性 (也就是資料欄位)",
                        outputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：該筆電影的系統唯一ID，藉由此ID可再進一步查詢該電影的細節內容、演職員表、相關藏品等。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryOne",
                                iType:"String",
                                iText:"<div>電影種類 (長短片)：該電影是長片或短片。</div>"
                            },
                            {
                                iTitle:"Movie_SubCategoryTwo",
                                iType:"String",
                                iText:"<div>電影種類：該電影的種類，如劇情片、紀錄片等。</div>"
                            },
                            {
                                iTitle:"Movie_TitleMain",
                                iType:"String",
                                iText:"<div>電影主要片名：該電影的主要片名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleTranslation",
                                iType:"String",
                                iText:"<div>電影翻譯片名：該電影的英譯或其他語言的譯名。</div>"
                            },
                            {
                                iTitle:"Movie_TitleOther",
                                iType:"String",
                                iText:"<div>電影其他片名：該電影其他片名。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionDate",
                                iType:"String",
                                iText:"<div>電影出品日期：該電影的出品日期。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionLocation",
                                iType:"String",
                                iText:"<div>電影出品國家：該電影的出品國家。</div>"
                            },
                            {
                                iTitle:"Movie_ProductionCompany",
                                iType:"String",
                                iText:"<div>電影製作公司：該電影的製作公司。</div>"
                            },
                            {
                                iTitle:"Movie_Producer",
                                iType:"String",
                                iText:"<div>電影製作人：該電影的製作人。</div>"
                            },
                            {
                                iTitle:"Movie_DramaContent",
                                iType:"String",
                                iText:"<div>電影劇情大綱：該電影的劇情介紹。</div>"
                            },
                            {
                                iTitle:"Movie_Rating",
                                iType:"String",
                                iText:"<div>電影分級：該電影的分級。</div>"
                            },
                            {
                                iTitle:"Movie_Language",
                                iType:"String",
                                iText:"<div>電影語言：該電影的語言。</div>"
                            },
                            {
                                iTitle:"Movie_TotalCount",
                                iType:"String",
                                iText:"<div>搜尋結果總筆數：本次搜尋所搜尋到的電影總筆數。</div>"
                            },
                        ]
                    },
                    {
                        number:"1.4",
                        spTitle:"電影權威資料 電影演員表 API",
                        spText:"使用者輸入電影的系統識別號後，API即回傳此部的電影演員表 (不包括職員表、相關藏品、主要資訊)",
                        spUrl:"/api/movie/fetch/MovieActorList/:Movie_SysID",
                        inputTableText:null,
                        inputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：每部電影權威資料的識別ID。</div>"
                            }
                        ],
                        outputTableText:"本隻API呼叫成功後，搜尋結果將會以陣列回傳，此部電影的每個演員資料都是陣列中的一個物件，資料的欄位以物件屬性呈現，以下說明各物件屬性 (也就是資料欄位)",
                        outputTable:[
                            {
                                iTitle:"Movie_Unit",
                                iType:"String",
                                iText:"<div>電影單元：此演員是演出本部電影的哪一個單元 (如《大輪迴》中的<第一世>)。</div>"
                            },
                            {
                                iTitle:"Movie_ActorName",
                                iType:"String",
                                iText:"<div>演員姓名：演員的姓名，如：林青霞。</div>"
                            },
                            {
                                iTitle:"Movie_RoleName",
                                iType:"String",
                                iText:"<div>腳色名稱：演員於本片飾演的腳色名稱，如：東方不敗。</div>"
                            },
                            {
                                iTitle:"Movie_RoleDescript",
                                iType:"String",
                                iText:"<div>腳色說明：說明該腳色，如：東方不敗，本片主要反派。</div>"
                            },
                            {
                                iTitle:"Movie_ActorNote",
                                iType:"String",
                                iText:"<div>備註說明：本筆演員資料的其他說明。</div>"
                            }
                        ]

                    },
                    {
                        number:"1.5",
                        spTitle:"電影權威資料 電影職員表 API",
                        spText:"使用者輸入電影的系統識別號後，API即回傳此部的電影職員表 (不包括演員表、相關藏品、主要資訊)",
                        spUrl:"/api/movie/fetch/MovieStaffList/:Movie_SysID",
                        inputTableText:null,
                        inputTable:[
                            {
                                iTitle:"Movie_SysID",
                                iType:"String",
                                iText:"<div>電影系統識別號：每部電影權威資料的識別ID。</div>"
                            }
                        ],
                        outputTableText:"本隻API呼叫成功後，搜尋結果將會以陣列回傳，此部電影的每個職員資料都是陣列中的一個物件，資料的欄位以物件屬性呈現，以下說明各物件屬性 (也就是資料欄位)",
                        outputTable:[
                            {
                                iTitle:"Movie_Unit",
                                iType:"String",
                                iText:"<div>電影單元：此工作人員是參與本部電影的哪一個單元 (如《大輪迴》中的<第一世>)。</div>"
                            },
                            {
                                iTitle:"Movie_Position",
                                iType:"String",
                                iText:"<div>職位名稱：此工作人員於本片的職稱，如：導演</div>"

                            },
                            {
                                iTitle:"Movie_StaffName",
                                iType:"String",
                                iText:"<div>職員姓名：職員的姓名，如：林福地。</div>"
                            },
                            {
                                iTitle:"Movie_Company",
                                iType:"String",
                                iText:"<div>公司名稱：有些工作執行可能是由外包公司進行，非個人，如：臺北沖印公司。</div>"
                            },
                            {
                                iTitle:"Movie_MusicTitle",
                                iType:"String",
                                iText:"<div>配樂曲名：如該工作人員為參與本部電影的配樂方面工作，則說明其參與的是那首配樂，如：<樂逍遙>。</div>"
                            }
                        ]
                    }
                    
                ]
            }
        ]
    }
}